/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useState, useRef, useEffect, useCallback } from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import MainHeader from "../../../../Shared/components/Header";
import SalesIcon from "../../../../../assets/images/icon_menus/SalesIcon.json";
import clsx from 'clsx';
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard";
import { Row, Col, Image, Space } from "antd";
import { checkComponentPermission, checkCRUDPermission, checkViewPermission, idNamingConversion } from '../../../../../helpers/utilities';
import { TextField } from "@mui/material";
import usePrevious from "../../../../Shared/components/Previous";
import SearchIcon from "../../../../../assets/images/icon_actions/Search Icon.svg";
import { Link, NavLink } from "react-router-dom";
import AddIcon from "../../../../../assets/images/icon_actions/Add Icon.svg";
import { SchedulingTable } from "./SchedulingTable";
import { useDispatch, useSelector } from "react-redux";
import crudActions from "../../../../CRUD/redux/actions";
import ExportIcon from "../../../../../assets/images/icon_actions/Export.svg";
import ClearIcon from "../../../../../assets/images/icon_actions/Clear Icon.svg";
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";
import salesActions from "../../../../Sales/Management/redux/actions";


export default function CustomersProductScheduling(props) {
    const { roleManagement } = useSelector(state => state.authReducer);
    const { getList, getData } = useSelector(state => state.crudReducer);
    const [search, setSearch] = useState('');
    const [iconAnimation, setIconAnimation] = useState(false);
    const { customerDetails } = useSelector(state => state.salesManagementReducer);
    const prevSearch = usePrevious(search);
    const [skip, setSkip] = useState(0);
    const timeoutRef = useRef(null);
    const [sortOrder, setSortOrder] = useState("desc");
    const [sortBy, setSortBy] = useState("id");
    const limit = 25;
    const [loadMoreContent, setLoadMoreContent] = useState(false);
    const [loadMore, setLoadMore] = useState(false);
    const { history } = props;
    const [customerId, setCustomerId] = useState('');
    const dispatch = useDispatch();

    useEffect(() => {
        if (roleManagement !== '') {
            if (checkViewPermission('Customer Product Scheduling', history, 'Sales')) {
                loadTasks();
                customerApi();
            }
        }
        return () => {
            dispatch({ type: salesActions.CLEAR_MANAGEMENT_DETAILS_START });
        };
    }, [roleManagement]);

    useEffect(() => {
        if ((prevSearch !== undefined && search && search.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                dispatchFilter(customerId, sortBy, sortOrder);
            } else {
                timeoutRef.current = setTimeout(() => {
                    timeoutRef.current = null;
                    dispatchFilter(customerId, sortBy, sortOrder);
                }, 500);
            }
        }
    }, [search]);

    const prevGetData = usePrevious(getData);
    useEffect(() => {
        if (loadMore && getData === '') {
            setLoadMoreContent(false);
            setLoadMore(true);
        }
        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            const timer = setTimeout(() => {
                if (getData && Array.isArray(getData) && getData.length > 0) {
                    setLoadMore(true);
                    if (getData.length < limit) {
                        setLoadMoreContent(false);
                    } else {
                        setLoadMoreContent(true);
                    }
                } else {
                    setLoadMoreContent(false);
                    setLoadMore(true);
                }
            });

            return () => {
                clearTimeout(timer);
            };
        }
    }, [getData]);

    const requestSort = (sortBy, sortOrder) => {
        setSortBy(sortBy);
        setSortOrder(sortOrder);
        dispatchFilter(customerId, sortBy, sortOrder);
    }

    const loadMoreTask = () => {
        let s = skip + limit;
        dispatchFilter(customerId, sortBy, sortOrder, s);
    }

    const customObject = (details, id) => {
        let a = details && details.filter((el) => el.id === id);
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    const loadTasks = useCallback(() => {
        dispatchFilter(customerId, sortBy, sortOrder);
    });

    const loadImportExportData = (name, data = 'existing', selected = [], extension = 'xlsx') => {
        dispatch({
            type: crudActions.EXPORT_START,
            export: name,
            data: data,
            selected: selected,
            extension: extension,
            url: 'v1/schedules/customer-schedules',
            filter: {
                order: sortBy + ' ' + sortOrder,
            }
        });
    }


    const dispatchFilter = (customerId, sortBy, sortOrder, skip = 0) => {
        if (skip === 0) {
            setLoadMore(false);
            setLoadMoreContent(false);
        }
        let filter = { ["and"]: [] };
        let or = { ["or"]: [] };

        if (customerId) {
            filter['and'].push({ customerId: customerId });
        }

        if (search !== '') {
            or['or'].push({ email: { like: '%' + search.trim() + '%' } });
            or['or'].push({ phone: { like: '%' + search.trim() + '%' } });
            or['or'].push({ billFormat: { like: '%' + search.trim() + '%' } });
        }
        filter['and'].push(or);
        setSkip(skip);
        dispatch({
            type: crudActions.GET_DETAILS_START,
            url: 'v1/schedules/customer-schedules',
            skip: skip,
            filter: {
                where: filter,
                order: sortBy + ' ' + sortOrder,
                limit: limit,
                skip: skip,
            }
        });
    }

    const handleChangeCustomer = (value) => {
        setCustomerId(value);
        dispatchFilter(value, sortBy, sortOrder);
    }

    const customerApi = (search = '', id = '') => {
        let filter = { ["or"]: [] };
        if (search !== undefined && search !== null && search !== '') {
            filter['or'].push({ name: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ serialNo: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ mobile: { like: '%' + search.trim() + '%' } });
        }

        if (id !== undefined && id !== null && id !== '') {
            filter['or'].push({ id: id });
        }

        dispatch({
            type: salesActions.CUSTOMER_DETAILS_START, url: 'customerProfile',
            filter: {
                where: filter,
                order: 'id desc',
                limit: 50,
                skip: 0
            },
        });
    }

    const classes = customStyles();
    return (
        <Fragment>
            <MainHeader {...props} cls={'newImg'} img={SalesIcon} title={'Sales'}
                closeLink={'/sales'}
                links={[{ 'label': 'Sales', 'link': '/sales' }, { 'label': 'Customer Product Scheduling', 'link': '' }]} />
            <div className={clsx(classes.margin40, classes.listTableMargin)}>
                <PrimaryCard
                    title={'Customer Product Scheduling'}
                    component={
                        <>
                            <Row align="middle" className={classes.marginBottom20}>
                                <Col xxl={6} xl={7} lg={8} md={10} sm={13} xs={24}>
                                    {
                                        roleManagement !== '' && checkComponentPermission('Customer Product Scheduling', 'Action', 'Search') &&
                                        <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation || search !== '' })}>
                                            <TextField autoComplete='one-time-code'
                                                placeholder='Search'
                                                type='search'
                                                value={search}
                                                onChange={(e) => setSearch(e.target.value)}
                                                className={classes.comInput}
                                                variant={'standard'}
                                                fullWidth
                                                id={idNamingConversion('Search', 'customerProductScheduling', 'TextField')}
                                                onFocus={() => setIconAnimation(true)}
                                                onBlur={() => setIconAnimation(false)}
                                            />
                                            <Image
                                                src={SearchIcon}
                                                preview={false}
                                            />
                                            {
                                                search && <NavLink to="#" onClick={() => setSearch('')} className={classes.searchClear}>
                                                    <Image
                                                        src={ClearIcon}
                                                        preview={false}
                                                    />
                                                </NavLink>
                                            }
                                        </div>
                                    }
                                </Col>
                                <Col xxl={18} xl={17} lg={16} md={14} sm={11} xs={24}
                                    className={clsx(classes.textAlignRight, classes.removeUnderline, classes.customerLabelNone, classes.vertiCalScrollOverFlowParent)}>
                                    <div className={classes.vertiCalScrollOverFlow}>
                                        <Space size={[20, 20]} direction="horizontal" align="center">
                                            {
                                                roleManagement !== '' && checkComponentPermission('Customer Product Scheduling', 'Action', 'All Customer') &&
                                                <AutoCompleteComponent
                                                    customLabel={"All Customers "}
                                                    heads={[{ 'key': 'name', 'name': 'Name' }]}
                                                    details={customerDetails}
                                                    customClasses={classes.customWidth172P}
                                                    position={"bottom"}
                                                    id={idNamingConversion('All Customers', 'customerProductScheduling', 'DropDown')}
                                                    variant={'outlined'}
                                                    parentValue={customObject(customerDetails, customerId)}
                                                    onChangeText={(data) => {
                                                        if (data === '') {
                                                            handleChangeCustomer(data);
                                                        }
                                                    }}
                                                    searchType={(s) => customerApi(s)}
                                                    onChange={(data) => handleChangeCustomer(data.id)}
                                                />
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Customer Product Scheduling', 'Action', 'Export') &&
                                                <Link
                                                    to={'#'}
                                                    id={idNamingConversion('Export', 'customerProductScheduling', 'Link')}
                                                    onClick={() => loadImportExportData('CustomerScheduling')}
                                                    className={clsx(classes.customLink)}>
                                                    <Image
                                                        src={ExportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /><span className={clsx(classes.addLink, classes.color, classes.bold)}>Export</span>
                                                </Link>
                                            }
                                            {
                                                roleManagement !== '' && checkCRUDPermission('Customer Product Scheduling', 'create', 'Sales') &&
                                                <Link
                                                    id={idNamingConversion('Add', 'customerProductScheduling', 'Link')}
                                                    to={"/sales/setup/customer-product-scheduling/create"}
                                                    className={clsx(classes.customLink)}>
                                                    <Image
                                                        src={AddIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /><span className={clsx(classes.addLink, classes.color, classes.bold)}>Add</span>
                                                </Link>
                                            }
                                        </Space>
                                    </div>
                                </Col>
                            </Row>
                            <SchedulingTable
                                customObject={(details, id) => customObject(details, id)}
                                search={search}
                                loadTasks={() => loadTasks()}
                                details={getList}
                                loadMore={loadMore}
                                loadMoreContent={loadMoreContent}
                                loadMoreTask={() => loadMoreTask()}
                                sortBy={sortBy} sortOrder={sortOrder}
                                roleManagement={roleManagement}
                                onRequestSort={(sortBy, sortOrder) => requestSort(sortBy, sortOrder)} />
                        </>
                    }
                />
            </div>
        </Fragment>
    )
}